import React from "react";
import "./TransactionDetailModal.css";

export default function TransactionDetailModal({
    open,
    onClose,
    data,
    onQuery,   // callback khi nhấn nút “Truy vấn”
}) {
    if (!open || !data) return null;

    const isChoTraSoat =
        data.trangThai?.toLowerCase() === "chờ tra soát" ||
        data.trangThai?.toLowerCase() === "chờ tra soát"; // để phòng lỗi dấu

    return (
        <div className="tdm-overlay" onClick={onClose}>
            <div className="tdm-modal" onClick={(e) => e.stopPropagation()}>

                {/* Header */}
                <div className="tdm-header">
                    <h3>Chi tiết Giao dịch</h3>
                    <span className="tdm-close" onClick={onClose}>✕</span>
                </div>

                {/* BODY */}
                <div className="tdm-body">

                    <div className="tdm-grid">

                        <div className="tdm-item">
                            <label>Số giao dịch</label>
                            <span>{data.soGiaoDich}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Số REF Hạch toán</label>
                            <span>{data.soRef}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Ngày giao dịch</label>
                            <span>{data.ngayGD}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Giờ giao dịch</label>
                            <span>{data.gioGD}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Số tiền</label>
                            <span>{data.soTien}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Phí VAT</label>
                            <span>{data.phiVat}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Loại giao dịch</label>
                            <span>{data.loaiGD}</span>
                        </div>

                        <div className="tdm-item">
                            <label>CIF (Mã khách hàng)</label>
                            <span>{data.cif}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Số tài khoản</label>
                            <span>{data.soTK}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Tên tài khoản</label>
                            <span>{data.tenTK}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Người thực hiện</label>
                            <span>{data.userThucHien}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Đại lý</label>
                            <span>{data.daiLy}</span>
                        </div>

                        <div className="tdm-item">
                            <label>Trạng thái</label>
                            <span>{data.trangThai}</span>
                        </div>

                    </div>

                    {/* BUTTON TRUY VẤN (chỉ hiển thị khi Chờ tra soát) */}
                    {isChoTraSoat && (
                        <button className="tdm-query-btn" onClick={onQuery}>
                            <img
                                src="/icons/icons8-loop-100.png"
                                className="tdm-query-icon"
                            />
                            Truy vấn
                        </button>
                    )}

                </div>
            </div>
        </div>
    );
}
